<template>
  <div class="wrapper" :id="slug">
    <el-row>
      <el-col :span="24" class="selector">
        <div>
          <div class="header-container">
            <h2 class="heading">
              {{ title }}
            </h2>
          </div>
        </div>
        <el-row>
          <el-col :span="22" :offset="1">
            <el-row type="flex" class="products">
              <template v-for="childCategory in childCategoriesWithProducts">
                <el-col
                  v-for="product in childCategory.products"
                  v-bind:key="`product-${product.id}`"
                  class="product-card-wrapper"
                  :xl="{ span: 4 }"
                  :lg="{ span: 6 }"
                  :md="{ span: 8 }"
                  :sm="{ span: 12 }"
                  :xs="{ span: 24 }"
                >
                  <product-card-view
                    :categoryTitle="childCategory.title"
                    :product="product"
                    :currentUser="currentUser"
                    :interactiveFavorite="true"
                    :productsPage="true"
                    :shadowOnHover="true"
                  />
                </el-col>
              </template>
              <el-col
                v-for="product in products"
                v-bind:key="`product-${product.id}`"
                class="product-card-wrapper"
                :xl="{ span: 4 }"
                :lg="{ span: 6 }"
                :md="{ span: 8 }"
                :sm="{ span: 12 }"
                :xs="{ span: 24 }"
              >
                <product-card-view
                  :categoryTitle="title"
                  :product="product"
                  :currentUser="currentUser"
                  :interactiveFavorite="true"
                  :productsPage="true"
                  :shadowOnHover="true"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import products from '.';
import user from '../user';
import ProductCardView from './ProductCardView';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ProductSubCategory',
  props: {
    category: {
      required: true,
      type: Object,
    },
  },
  components: {
    ProductCardView,
  },
  computed: {
    ...mapState(user.store.namespace, ['currentUser']),
    ...mapGetters(products.store.namespace, ['getMenuProductsByCategory']),
    slug() {
      return this.category.slug;
    },
    title() {
      return this.category.title;
    },
    products() {
      return this.getMenuProductsByCategory(this.category.id);
    },
    childCategoriesWithProducts() {
      let childCategories = [];
      if (this.category.children) {
        (
          this.category.children.forEach((child) => {
            let childCategory = { ...child };
            childCategory.products = this.getMenuProductsByCategory(
              childCategory.id
            );
            childCategory.hasProducts =
              childCategory.products && childCategory.products.length > 0;
            childCategories.push(childCategory);
          }) || []
        ).filter((category) => category.hasProducts);
      }
      return childCategories;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.wrapper {
  margin-top: 75px;

  // adjust image height by resolution to handle different
  // numbers of cards per row

  @include res(xl-only, $--breakpoints-spec) {
    --image-height: 12vw;
  }

  @include res(lg-only, $--breakpoints-spec) {
    --image-height: 18vw;
  }

  @include res(md-only, $--breakpoints-spec) {
    --image-height: 24vw;
  }

  @include res(sm-only, $--breakpoints-spec) {
    --image-height: 36vw;
  }

  @include res(xs-only, $--breakpoints-spec) {
    --image-height: 72vw;
  }
}

.heading {
  color: $--color-white;
  padding: 25px 0px;
  margin-left: 100px;
  @include res(sm-and-down, $--breakpoints-spec) {
    font-size: 24px;
    margin-left: 16px;
  }
}

.header-container {
  // This gradient fills up any space to the left of the svg without overfilling the transparent parts
  background-image: linear-gradient(
      90deg,
      rgba(0, 58, 81, 1) 0%,
      rgba(0, 58, 81, 1) calc(100% - 441px),
      rgba(8, 55, 76, 0) calc(100% - 440px),
      rgba(87, 22, 28, 0) 100%
    ),
    url('@/assets/images/large-rectangle-background.svg');
  background-position: left top, right top;
  background-repeat: no-repeat, no-repeat;

  // Min-width matches the width of the SVG itself
  width: max-content;
  padding-right: 40px;
  min-width: 450px;
}

.products {
  flex-wrap: wrap;
  margin-top: 60px;
}

.product-card-wrapper {
  padding: 10px;
}
</style>
